"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M12 14V9", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M12 17V15.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M4.30633 17.3929L10.9073 5.5112C11.3836 4.65394 12.6164 4.65394 13.0927 5.5112L19.6937 17.3929C20.1565 18.2261 19.5541 19.25 18.601 19.25H5.39903C4.44592 19.25 3.84346 18.2261 4.30633 17.3929Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "square" })));
